import React from 'react';
import { observer, inject } from 'mobx-react';
import SourceLayout from './SourceLayout';
import LayoutTr from './LayoutTr';
import CustomContent from './CustomContent';
import HiddenArea from './HiddenArea';
import PromptBox from './PromptBox';
import * as Util from '../../util/formUtil';
import * as GlobalUtil from '../../util/public/globalUtil';
import * as Parse from '../../util/public/parseLayout';

@inject('globalStore', 'layoutStore')
@observer
export default class MainLayout extends React.Component {
    componentDidMount() {
        const { symbol,globalStore }  = this.props;
        const isMain = symbol === "main" ? true : false;
        const { JSComplete,commonParam, urlParams } = globalStore;
        const { isBatchPrint } = urlParams;
        try{
            if(isMain){
              if(jQuery('.wf-req-form-content').css('display') == 'none') return 
                //设置标题
                let title = Util.getPageTitle();;
                document.title = title;
                if(window.top &&
                    ( window.top.location.pathname.indexOf("/spa/workflow/index_form.jsp")>-1 ||
                    window.top.location.pathname.indexOf("/spa/workflow/static4form/index.html")>-1)
                ){
                    window.top.document.title = title;
                }
                if(isBatchPrint === "true"){//批量打印显示链接
                    window.top.document.title = "";
                }
                //模板列宽超过一屏时，计算div宽度撑开body的横向滚动条
                const layoutWidth = parseFloat(jQuery("table.excelMainTable").width());
                const wrapperDiv = jQuery("div.wf-req-form-main");
                if(layoutWidth > wrapperDiv.width() && wrapperDiv.width() > 0){
                    wrapperDiv.width(layoutWidth + 100);
                    wrapperDiv.parent().css("overflow-x", "auto");
                }
                //系统提醒工作流特殊处理
                if(commonParam.workflowid == 1)
                    errorNoticeUtil.handleResetBtn();
                //图片懒加载
                formImgLazyLoad(jQuery('.wea-new-top-req-content'));
            }
        }catch(e){
            if(window.console)  console.log("MainLayout componentDidMount Exception");
        }
    }
    render(){
        const { symbol,globalStore,layoutStore }  = this.props;
        const isMain = symbol === "main" ? true : false;
        const { isSourceLayout,urlParams={}, } = globalStore;
        const {isBatchPrint}=urlParams
        const { variableMap,propFileCfg={} } = layoutStore;
        const { batch_print_control_width } = propFileCfg
        const promptBoxProp = variableMap.has("promptBox") ? variableMap.get("promptBox") : {};
        const mainDom = [];
        if(isMain){
            mainDom.push(<CustomContent ecId={`${this && this.props && this.props.ecId || ''}_CustomContent@4gt3x5`} />);
            mainDom.push(<HiddenArea ecId={`${this && this.props && this.props.ecId || ''}_HiddenArea@rsshkl`} />);
            mainDom.push(<PromptBox ecId={`${this && this.props && this.props.ecId || ''}_PromptBox@h72bxt`} {...promptBoxProp} />);
        }
        let layout = null;
        if(isSourceLayout){
            layout = <SourceLayout ecId={`${this && this.props && this.props.ecId || ''}_SourceLayout@yd276x`} />;
        }else{
            layout = this.renderExcelLayout();
        }
        let canControlWidth =  parseInt(batch_print_control_width) > 100;
        let tableStyle =( isBatchPrint && canControlWidth) ? {maxWidth:parseInt(batch_print_control_width)+"px", margin:"0 auto"} : {}
        return (
            <div className={isMain ? "excelTempDiv" : ""} style={tableStyle}>
                { layout }
                { mainDom }
            </div>
        )
    }
    renderExcelLayout() {
        const { symbol,globalStore,layoutStore }  = this.props;
        const isMain = symbol === "main" ? true : false;
        const jsonKey = isMain ? "emaintable": symbol;
        const { browserVersion,commonParam, urlParams={} } = globalStore;
        const { layouttype } = commonParam;
        const { isBatchPrint } = urlParams;
        const { dataJson,cellInfo } = layoutStore;
        let breakpage_row = cellInfo.printBreakRowInfo || [];
        const etables = dataJson.etables;
        const etable =  jsonKey in etables ? etables[jsonKey] : null;
        if(etable == null)
            return <div style={{"display": "none"}}>Layout error</div>

        let className = isMain ? "excelMainTable" : "excelTabTable";
        let tableStyle = isMain ? {margin:"0px auto"} : {};
        if(cellInfo.isFixed == "1" || GlobalUtil.judgeExistXScrollDetail())
            tableStyle["table-layout"] = "fixed";
        if(isMain && browserVersion.indexOf("IE") > -1 && cellInfo.existTextArea === true)  //IE下多行文本内容撑开问题
            tableStyle["table-layout"] = "fixed";
        const rowHeads = Parse.convertRowHeads(etable.rowheads);
        const colHeads = Parse.convertColHeads(etable.colheads, symbol, layouttype, tableStyle);
        const ecMap = Parse.convertEcMap(etable.ec);
        const rowattrs = etable.rowattrs;
        const colattrs = etable.colattrs;
        let domArr = this.getDomArr(rowHeads, breakpage_row);
        let renderDoms = [];
        let tablenum=0;
        domArr.map((item,index) => {
            const { trArr_rowHeads } = item;
            if (item.flag == "table") {
                let trArr = [];
                if(index === 0)
                    Parse.parseLayoutImage(etable, tableStyle, trArr);    //解析背景图、悬浮图
                trArr_rowHeads.map((o) => {
                    const rowid = o.id;
                    if(isBatchPrint === "true" && breakpage_row.includes(parseInt(rowid)))
                       return;
                    const rowCusAttr = rowattrs ? rowattrs["row_" + rowid] : null;
                    //分组节点意见循环行、非意见默认循环一行
                    const nodeSignProps = this.calculateNodeSignProps(rowid);
                    for (let i = 0; i < nodeSignProps.total; i++) {
                        trArr.push(<LayoutTr ecId={`${this && this.props && this.props.ecId || ''}_LayoutTr@ds2cqb@${symbol}_${i}`}
                            symbol={symbol}
                            colNum={colHeads.length}
                            rowid={rowid}
                            rowHeight={o.height}
                            rowCusAttr={rowCusAttr}
                            colattrs={colattrs}
                            ecMap={ecMap}
                            nodeSignProps={{ ...nodeSignProps, ...{ current: i } }}
                        />);
                    }
                });
                renderDoms.push(
                    <table className={className} style={{ ...tableStyle}}>
                        <colgroup>
                            {colHeads.map(v => <col style={{ width: v.width }} />)}
                        </colgroup>
                        <tbody>
                            {trArr}
                        </tbody>
                    </table>
                );
            } else {
                renderDoms.push(<div style={{ height: trArr_rowHeads[trArr_rowHeads.length - 1].height, pageBreakAfter: "always"  }} />)
            }
        })
        return renderDoms;
    }
    getDomArr = (_rowHeads, breakpage_row) => {
        const { symbol, globalStore} = this.props;
        const { urlParams = {} } = globalStore;
        const { isBatchPrint } = urlParams;
        let rowHeads = [..._rowHeads]
        let domArr = [];
        if (symbol === "main" && breakpage_row.length > 0 && isBatchPrint !== "true") {
            breakpage_row.sort((a,b)=>a-b);
            let breakpageRow = breakpage_row[0];
            domArr.push({ trArr_rowHeads: rowHeads.slice(0, breakpage_row[0]), flag: "table" })
            domArr.push({ trArr_rowHeads: [rowHeads[breakpageRow]], flag: "pagebreak" })
            for (let i = 1; i < breakpage_row.length; i++) {
                breakpageRow=breakpage_row[i];
                domArr.push({ trArr_rowHeads: rowHeads.slice(breakpage_row[i - 1] + 1, breakpageRow), flag: "table" })
                domArr.push({ trArr_rowHeads: [rowHeads[breakpageRow]], flag: "pagebreak" })
            }
            domArr.push({ trArr_rowHeads: rowHeads.slice(breakpage_row[breakpage_row.length - 1] + 1), flag: "table" })
        } else {
            domArr = [{ trArr_rowHeads: rowHeads, flag: "table" }]
        }
        return domArr;
    }

    calculateNodeSignProps(rowid){
        const { symbol,layoutStore }  = this.props;
        const { cellInfo } = layoutStore;
        const { nodeMarkGroup,nodeMarkContent } = cellInfo;
        const key = `${symbol}_${rowid}`;
        let belong = false;
        let total = 1;
        let cellKey = "";
        nodeMarkGroup && nodeMarkGroup.map(item =>{
            const rowKey = `${item.symbol}_${item.rowid}`;
            if(`${symbol}_${rowid}` === rowKey){
                belong = true;
                cellKey = `${item.symbol}_${item.rowid}_${item.colid}`;
                total = cellKey in nodeMarkContent && nodeMarkContent[cellKey] instanceof Array? nodeMarkContent[cellKey].length : 0;
            }
        });
        return {belong, total, cellKey};
    }
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/workflowForm/components/layout/MainLayout.js